export const unifiedState = { enabled: false, csrfToken: '', accountUrl: '' };
export function setUnifiedConfiguration(config) {
  unifiedState.enabled = config.enabled === true;
  unifiedState.csrfToken = config.csrf_token || '';
  unifiedState.accountUrl = config.account_url || '';
}
export function unifiedLoginUrl(mode = 'login', returnTo) {
  const query = new URLSearchParams(window.location.search);
  const next = returnTo ?? (query.get('returnTo') || '/');
  const params = new URLSearchParams({ mode, returnTo: next });
  return (process.env.REACT_APP_API_BASE_URL || '/api') + '/auth/sso/login/?' + params;
}
